import { useState, useEffect } from 'react';

const links = [
  { label: 'About',    href: '#about' },
  { label: 'Skills',   href: '#skills' },
  { label: 'Work',     href: '#projects' },
  { label: 'Contact',  href: '#contact' },
];

function smoothScroll(e, href) {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 88, behavior: 'smooth' });
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
      background: scrolled ? 'rgba(13,13,13,0.96)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px)' : 'none',
      borderBottom: scrolled ? '1px solid #2a2a2a' : '1px solid transparent',
      transition: 'all 0.4s ease',
    }}>
      <div className="page-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1.25rem 2rem' }}>

        {/* Logo */}
        <a href="#home" onClick={e => smoothScroll(e, '#home')} style={{ textDecoration: 'none' }}>
          <span style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: '1.3rem',
            color: 'var(--white)',
            letterSpacing: '-0.01em',
          }}>
            P.<span style={{ color: 'var(--gold)' }}>K</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav style={{ display: 'flex', gap: '2.5rem', alignItems: 'center' }} className="desktop-nav">
          {links.map(l => (
            <a key={l.label} href={l.href} onClick={e => smoothScroll(e, l.href)} className="nav-item">{l.label}</a>
          ))}
          <a href="mailto:pradeepkumarsirigirisetty@gmail.com" className="btn btn-gold" style={{ padding: '0.55rem 1.25rem' }}>
            Hire Me
          </a>
        </nav>

        {/* Mobile toggle */}
        <button onClick={() => setOpen(o => !o)} aria-label="Toggle menu"
          style={{ background:'none', border:'none', color:'var(--white)', fontSize:'1.4rem', cursor:'pointer', display:'none' }}
          className="mobile-toggle">
          {open ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: 'var(--bg)',
          borderBottom: '1px solid var(--border)',
          padding: '2rem',
        }}>
          {links.map(l => (
            <a key={l.label} href={l.href}
              onClick={e => { smoothScroll(e, l.href); setOpen(false); }}
              style={{
                display: 'block', padding: '1rem 0',
                borderBottom: '1px solid var(--border)',
                color: 'var(--white)', textDecoration: 'none',
                fontFamily: 'var(--font-display)', fontSize: '1.5rem',
              }}>
              {l.label}
            </a>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-toggle { display: block !important; }
        }
      `}</style>
    </header>
  );
}
